import { useMutation, useQueryClient } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"

import { ActionLinkExecutionInput, executeActionLink, performActionLinkRequest } from "./api"

export function useExecuteActionLink() {
  const getContext = useApiContext()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id, input }: { id: string; input?: ActionLinkExecutionInput }) => {
      const context = await getContext()
      if (!context) throw new Error("No context found")

      const response = await executeActionLink(context, id, input)
      return response.data
    },
    onSuccess: async (data, variables) => {
      // Handle ModifyRecord type - make the actual API call
      if (data.endpoint) {
        const context = await getContext()
        if (!context) throw new Error("No context found")

        await performActionLinkRequest(context, data.http_method || "POST", data.endpoint, data.params)
      }

      // Use the invalidate_queries from the action link
      if (data.invalidate_queries) {
        data.invalidate_queries.forEach((queryKey: string[]) => {
          queryClient.invalidateQueries({ queryKey })
        })
      }

      // Approval continuations start a new chat stream outside useChat's normal
      // submit flow. Refreshing the thread flips its `resume` flag so the chat
      // reconnects to that stream and renders the execution result.
      if (data.stream_id) {
        await queryClient.invalidateQueries({ queryKey: ["chat_thread"] })
      }

      await queryClient.invalidateQueries({ queryKey: ["action-link", variables.id] })
    },
  })
}
